import { render, staticRenderFns } from "./SidebarEditGroup.vue?vue&type=template&id=1c4d091c&"
import script from "./SidebarEditGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarEditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports